import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  TextField,
  Button,
  Box,
  Card,
  Typography,
  Switch,
  FormControlLabel,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { API_ENDPOINTS } from "../../../config/api";

const API_URL = API_ENDPOINTS.DELIVERY_TERMS;

const EditDeliveryTermForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [deliveryTerm, setdeliveryTerm] = useState({
    name: "",
    publish: false,
  });
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    fetchdeliveryTerm();
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchdeliveryTerm = async () => {
    try {
      const response = await axios.get(API_URL.GET(id));
      setdeliveryTerm({
        name: response.data.deliveryTerm.name || "",
        publish: response.data.deliveryTerm.publish || false,
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching delivery term:", error);
      setSnackbar({
        open: true,
        message: "Failed to load delivery term data",
        severity: "error",
      });
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setdeliveryTerm({ ...deliveryTerm, [e.target.name]: e.target.value });
  };

  const handlePublishToggle = () => {
    setdeliveryTerm((prev) => ({ ...prev, publish: !prev.publish }));
  };

  const handleUpdate = async () => {
    try {
      await axios.put(API_URL.EDIT(id), deliveryTerm);
      setSnackbar({
        open: true,
        message: "Delivery term updated successfully!",
        severity: "success",
      });
      // Navigate after a short delay to allow the success message to be seen
      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (error) {
      console.error("Error updating delivery term:", error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to update delivery term",
        severity: "error",
      });
    }
  };

  if (loading) {
    return <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />;
  }

  return (
    <Card sx={{ p: 4, maxWidth: 500, mx: "auto", mt: 5 }}>
      <Typography variant="h5" mb={3}>
        Edit Delivery Term
      </Typography>
      <Box display="flex" flexDirection="column" gap={3}>
        <TextField
          label="Delivery Term Name"
          name="name"
          value={deliveryTerm.name}
          onChange={handleChange}
          required
        />
        <FormControlLabel
          control={
            <Switch
              checked={deliveryTerm.publish}
              onChange={handlePublishToggle}
              color="primary"
            />
          }
          label="Published"
        />
        <Box display="flex" justifyContent="space-between" gap={2}>
          <Button variant="contained" color="primary" onClick={handleUpdate}>
            Update
          </Button>
          <Button variant="outlined" color="secondary" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </Box>
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default EditDeliveryTermForm;
